module.exports = __webpack_public_path__ + "img/yb-zc.e399f7ae.png";